import { AppState } from "@Store/index";
import { shallowEqual, useSelector } from "react-redux";

const useIsMiniProgram = () => {
  const { isMiniProgram } = useSelector(
    ({ appData }: AppState) => ({
      isMiniProgram: appData.isMiniProgram,
    }),
    shallowEqual,
  );
  return isMiniProgram;
};

export default useIsMiniProgram;
